import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";

const VIEW_ENTITY_TYPE_BY_STORAGE = {
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS]:
    UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_RESEARCH,
};

const toViewEntityType = (entityType) =>
  VIEW_ENTITY_TYPE_BY_STORAGE[entityType] || entityType;

export default toViewEntityType;
